import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import * as ApexCharts from 'apexcharts';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'app-opportunity-analysis',
	templateUrl: './opportunity-analysis.component.html',
	styleUrls: ['./opportunity-analysis.component.scss']
})
export class OpportunityAnalysisComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	graphSlideConfig = { slidesToShow: 2, slidesToScroll: 1, infinite: false, arrows: true, };
	user_details: any;

	@Input() selected_tab: any;
	@Input() stepper_stage: any;
	@Input() type: any;
	@Input() selected_opportunity_period: any;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
		private elementRef: ElementRef,
		private datePipe: DatePipe,
		private changeDetectorRef: ChangeDetectorRef,
	) { }

	ngOnInit(): void {
		window.scrollTo(0, 0);
		this.user_details = this.storageService.get("user_details");

		this.getPageSummary();

		this.getStages();

	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
			return null;
		}
		if (num === 0) {
			return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
		k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
		c =
		k < 1
		? num.toFixed(0 + fixed)
		: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
		d = c < 0 ? c : Math.abs(c),
		e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

	back() {
		const data = {
			clickable: true,
			name: 'Summary',
		};
		// this.stateChanged.emit(data);
	}

	page_state: any = "Follow Up";
	changePageState(data) {
		if (data.clickable == true) {
			this.page_state = data.name;
			this.getPageSummary();
		}
	}

	page_summary_loaded: boolean = false;
	page_summary_data: boolean = false;
	getPageSummary() {
		this.page_summary_loaded = false;

		this.page_graph_data_loaded = false;

    let route: any = "/clientsalesprocess/chartsupdatednew?duration=" + this.selected_opportunity_period + "&opportunity_type=" + this.type + "&opp_year=" + this.selected_opportunity_period;

    if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
     route = "/magidepositclientfollowup/charts?duration=" + this.selected_opportunity_period + "&opportunity_type=" + this.type + "&opp_year=" + this.selected_opportunity_period;
    }

		this.commonService.getData(route).subscribe(
			(res: any) => {


				this.page_summary_data = res['data'];

				this.selected_high_value_leads = res["data"]["total_leads"];

				if (this.show_graphical_representation == true) {
					setTimeout(() => {
						this.createOppYearGraph();
						this.createCommunicationChannelActivityGraph();
						this.createMonthlyActivityGraph();

						this.getUpsideOpportunityGraph();

						this.createAgeTriggerGraph();
						this.createDateTriggerGraph();
						this.createDataTriggerGraph();
            			this.createAITriggerGraph();

						if (this.user_details.role.business_area[0]==5){
							this.createClientValueGraph();
							this.createClientClosureGraph();
							this.createClientValueClosureGraph();
						}


					}, 100);
				}

				// if (this.show_analysis == true) {
				// 	this.showAnalysis();
				// }

				// this.getOpportunityGraph();

				this.getTableData();

				this.page_graph_data_loaded = true;

				this.page_summary_loaded = true;


			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.page_summary_loaded = true;
			},
		);
	}

	getKey(data, value) {
		return data[value];
	}

	selected_top_percentage: any = 100;
	selected_sale_type: any = "all";
	total_client_value: any = 0;
	total_aum_value: any = 0;
	total_wallet_share_value: any = "";
  	update_selected_high_value_leads: boolean = true;
	getOpportunitySummary() {
		// let type: any = "";
		// if (this.type == "Total Opportunities") {
		// 	if (this.selected_sale_type == "all") {
		// 		type = "Total Opportunities"
		// 	} else {
		// 		type = this.selected_sale_type;
		// 	}
		// } else if (this.type == "Up-Sell Opportunities") {
		// 	type = "Up-Sell Opportunities";
		// } else if (this.type == "Cross-Sell Opportunities") {
		// 	type = "Cross-Sell Opportunities";
		// } else if (this.type == "Upside Opportunities") {
		// 	type = "Upside Opportunities";
		// }
		this.commonService.getData("/salesprocessopportunity/" + this.selected_top_percentage + "/" + this.type + "?duration=" + this.selected_opportunity_period).subscribe(
			(res: any) => {
				this.total_client_value = res["total_clients"];
				this.total_aum_value = res["total_aum"];
				this.total_wallet_share_value = res["total_wallet_share"];

				this.selected_high_value_leads = this.total_client_value;

				// this.getHighValueLeadsDropdown(this.total_client_value);

				this.getAnanlyticalSummary();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);

	}

	selected_high_value_leads: any = 0;
	selected_analysis_value: any = 100;
	selected_client_value: any = 0;
	selected_aum_value: any = 0;
	selected_wallet_share_value: any = "";

	page_graph_data: any = {
		opportunity_graph: []
	};
	page_graph_data_loaded: boolean = false;

	opportunity_graph_loaded: boolean = false;

	getAnanlyticalSummary() {

		if (!this.selected_analysis_value) {
			this.selected_analysis_value = 10;
		}

		this.page_graph_data_loaded = false;
		// this.opportunity_graph_loaded = false;
		// let type: any = "";
		// if (this.type == "Total Opportunities") {
		// 	if (this.selected_sale_type == "all") {
		// 		type = "Total Opportunities"
		// 	} else {
		// 		type = this.selected_sale_type;
		// 	}
		// } else if (this.type == "Up-Sell Opportunities") {
		// 	type = "Up-Sell Opportunities";
		// } else if (this.type == "Cross-Sell Opportunities") {
		// 	type = "Cross-Sell Opportunities";
		// }


		this.commonService.getData("/salesprocessopportunitygraph/" + this.selected_top_percentage + "/" + this.selected_high_value_leads + "/" + this.selected_analysis_value + "/" + this.type + "?duration=" + this.selected_opportunity_period).subscribe(
			(res: any) => {

				this.total_client_value = res["total_clients"];
				this.total_aum_value = res["total_aum"];
				this.total_wallet_share_value = res["total_wallet_share"];

				this.selected_client_value = res["selected_total_clients"];

				// this.selected_client_value = res["selected_total_clients"];
				// this.selected_aum_value = res["selected_total_aum"];
				// this.selected_wallet_share_value = res["selected_wallet_share"];

				// if (this.update_selected_high_value_leads == true) {
				// 	// this.selected_high_value_leads = this.total_client_value;
				// 	this.selected_client_value = this.selected_high_value_leads;
				// 	this.update_selected_high_value_leads = false;
				// } else {
				// 	this.update_selected_high_value_leads = false;
				// }


				this.page_graph_data = res;

				if (this.show_graphical_representation == true) {
					setTimeout(() => {
						// if (this.type != "Up-Sell Opportunities") {
						// 	this.createAgeTriggerGraph();
						// 	this.createDateTriggerGraph();
						// 	this.createDataTriggerGraph();
						// }
						this.getUpsideOpportunityGraph();

						this.createAgeTriggerGraph();
						this.createDateTriggerGraph();
						this.createDataTriggerGraph();
						this.createAITriggerGraph();

						this.createClientValueGraph();
						this.createClientClosureGraph();
						this.createClientValueClosureGraph();


					}, 100);
				}

				// this.opportunity_graph_loaded = true;

				this.getOpportunityGraph();
				// this.segregateGraphAPIData([this.selected_top_percentage, this.selected_analysis_value]);

				// setTimeout(() => {
				// 	this.createOpportunityGraph();
				// 	// if (!this.opportunuty_graph) {
				// 	// 	this.createOpportunityGraph();
				// 	// } else {
				// 	// 	this.updateOpportunityGraph(this.page_graph_data['opportunity_graph']['data'], this.page_graph_data['opportunity_graph']['legends']);
				// 	// }
				// }, 100);

				this.getTableData();

				this.page_graph_data_loaded = true;

			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.page_graph_data_loaded = true;
			},
		);
	}

	graph_request_progess: boolean = false;
	graph_request_queue: any = [];
	segregateGraphAPIData(data) {
		this.graph_request_queue.push(data);

		this.processGraphQueue();
	}

	graph_process_queue_data: any = [];
	processGraphQueue() {
		if (this.graph_request_progess || this.graph_request_queue.length == 0) {
			return;
		}

		this.graph_process_queue_data = this.graph_request_queue.shift();

		this.getOpportunityGraph();
	}

	getData() {
	}

	opportunity_graph_data: any;
	opportunity_recomendation_data: any;
	getOpportunityGraph() {
		// this.opportunity_graph_loaded = false;
		this.graph_request_progess = true;
		// let type: any = "";
		// if (this.type == "Total Opportunities") {
		// 	if (this.selected_sale_type == "all") {
		// 		type = "Total Opportunities"
		// 	} else {
		// 		type = this.selected_sale_type;
		// 	}
		// } else if (this.type == "Up-Sell Opportunities") {
		// 	type = "Up-Sell Opportunities";
		// } else if (this.type == "Cross-Sell Opportunities") {
		// 	type = "Cross-Sell Opportunities";
		// }
		// this.commonService.getData("/salesprocesspiegraph/" + this.selected_top_percentage + "/" + this.selected_high_value_leads + "/" + this.selected_analysis_value + "/" + type + "?duration=" + this.selected_opportunity_period).subscribe(
		// 	(res: any) => {
		// 		this.opportunity_graph_data = res['opportunity_graph'];
		// 		this.selected_client_value = res["selected_total_clients"];
		// 		setTimeout(() => {
		// 			this.createOpportunityGraph();
		// 			// if (!this.opportunuty_graph) {
		// 			// 	this.createOpportunityGraph();
		// 			// } else {
		// 			// 	this.updateOpportunityGraph(this.page_graph_data['opportunity_graph']['data'], this.page_graph_data['opportunity_graph']['legends']);
		// 			// }
		// 		}, 100);

		// 		if (this.selected_page_action.name != "") {
		// 			this.getTableData();
		// 		}


		// 		this.graph_request_progess = false;
		// 	},
		// 	(err) => {
		// 		this.commonService.showToast('error', err.error);
		// 		this.graph_request_progess = false;
		// 	},
		// );

		// const selected_top_percentage = this.graph_process_queue_data[0];
		// const selected_analysis_value = this.graph_process_queue_data[1];


		// this.commonService.getData("/salesprocesspiegraph/" + this.selected_top_percentage + "/" + this.selected_high_value_leads + "/" + this.selected_analysis_value + "/" + type + "?duration=" + this.selected_opportunity_period).subscribe(

		this.commonService.getData("/salesprocesspiegraphupdated/" + this.type + "?duration=" + this.selected_opportunity_period).subscribe(
			(res: any) => {
				// this.opportunity_graph_data = res['opportunity_graph'];
				this.opportunity_graph_data = res["graph_data"];
				this.opportunity_recomendation_data = res["recommendation"];
				// this.selected_client_value = res["selected_total_clients"];
				this.selected_client_value = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]["selected_total_clients"];

				// this.opportunity_graph_loaded = true;

				// setTimeout(() => {
				// 	this.createOpportunityGraph();
				// 	// if (!this.opportunuty_graph) {
				// 	// 	this.createOpportunityGraph();
				// 	// } else {
				// 	// 	this.updateOpportunityGraph(this.page_graph_data['opportunity_graph']['data'], this.page_graph_data['opportunity_graph']['legends']);
				// 	// }
				// }, 100);
				this.createOpportunityGraph();

				this.getTableData();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
			// complete: () => {
			//   this.graph_request_progess = false;
			//   this.processGraphQueue();
			// }
		);
	}

	opportunuty_graph_options: any;
	opportunuty_graph: any;
	createOpportunityGraph() {
		this.opportunity_graph_loaded = false;
		this.opportunity_graph_loaded = true;

		setTimeout(() => {
			let $this = this;
			if ($this.opportunuty_graph) {
				$this.opportunuty_graph.destroy();
				// $this.updateOpportunityGraph($this.opportunity_graph_data['data'], $this.opportunity_graph_data['legends']);
			}

			const options = {
				colors: $this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['colors'],
				series: $this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['data'],
				chart: {
					type: 'pie',
					toolbar: {
						show: false,
					},
					zoom: {
						enabled: false,
					},
					height: 220,
				},
				noData: {
					text: 'No Data Available',
					align: 'center',
					verticalAlign: 'middle',
					offsetX: 0,
					offsetY: 0,
					style: {
						color: '#006AFF',
						fontSize: '24px',
						fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
					},
				},
				plotOptions: {
					pie: {
						startAngle: 0
					}
				},
				dataLabels: {
					enabled: false,
				},
				labels: $this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['legends'],
				legend: {
					position: 'bottom',
					enabled: false,
				},
				yaxis: {
					title: {
						text: '',
					},
				},
				fill: {
					opacity: 1,
				},
				tooltip: {
					custom: function ({ series, seriesIndex, dataPointIndex, w }) {
						return (
							'<div style="width:300px; padding:8px">' +
							'<p style="width:100%;text-overflow:clip;white-space:break-spaces">' +
							$this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['legends'][seriesIndex] +
							'</p>' +
							'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Opportunity</b>: $' +
							$this.commonService.abbreviateNumber($this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['data'][seriesIndex]) + '(' + $this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['data_percentage'][seriesIndex] + '% of Total Opportunity)' +
							'</p>' +
							'</div>'
						);
					},
					//  fixed: {
					//   enabled: true,
					//   position: "topRight"
					// }
				}
			};

			$this.opportunuty_graph = new ApexCharts(document.querySelector('#opportunity-graph'), options);
			$this.opportunuty_graph.render();

		}, 100);
	}

	updateOpportunityGraph(series, labels,) {
		this.opportunuty_graph.updateOptions({
			series: series,
			labels: labels
		});
		this.selected_high_value_leads = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]["selected_total_clients"];
		this.changeDetectorRef.detectChanges();
	}

	opportunitySliderChanged(event) {
		// this.selected_top_percentage = event.value;
		// const data = [event.value, this.selected_analysis_value];
		// this.segregateGraphAPIData(data);
		// this.getOpportunityGraph();

		this.selected_top_percentage = event.value;
		const series = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['data'];
		const labels = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['legends'];
		this.updateOpportunityGraph(series, labels);
	}

	opportunitySliderStopped() {
		// const data = [this.selected_top_percentage, this.selected_analysis_value];
		// this.segregateGraphAPIData(data);
		// this.getOpportunityGraph();

		const series = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['data'];
		const labels = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['legends'];
		this.updateOpportunityGraph(series, labels);

		// if (this.selected_page_action.name != "") {
		// 	this.getTableData();
		// }

		this.getTableData();

	}

	upsideOpportunitySliderChanged(event) {
		// this.selected_analysis_value = event.value;
		// const data = [this.selected_top_percentage, event.value];
		// this.segregateGraphAPIData(data);
		// this.getOpportunityGraph();

		this.selected_analysis_value = event.value;
		const series = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['data'];
		const labels = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['legends'];
		this.updateOpportunityGraph(series, labels);
	}

	validateSliderValue(event) {
		let value = event.target.value;

		const num = Number(value);

		if (num < 0) {
			event.target.value = 0;
		} else if (num > 100) {
			event.target.value = 100;
		}
	}

	page_summary_actions: any = [
		{
			name: "Contact Top Opportunities",
			description: "This action enables advisors to manually create or capture responses for the top selected opportunities for direct conversations",
			image: "assets/manual-task.png",
			background: "#A1C93E",
			action: "Note",
			action_type: "Manual Task",
		},
		{
			// name: "Capture Response",
			name: "Response from Automated Activity",
			description: "This action allows the advisors to capture the response of automated email activities for all opportunities",
			image: "assets/capture-response.png",
			background: "#EB9F2D",
			action: "Capture",
			action_type: "Capture Response",
		},
		{
			name: "Product Information",
			description: "This action allows the advisors to assign a product/ policy after sale is confirmed",
			image: "assets/product-information.png",
			background: "#55A1EF",
			action: "Add",
			action_type: "Product Information",
		}
	];

	selected_page_action: any = {
		name: ""
	};
	selectAction(data) {
		this.selected_page_action = data;
		this.selected_client = {
			id: ""
		};
		this.getTableData();
	}

	show_graphical_representation: boolean = false;
	toggleGraphs() {
		if (this.show_graphical_representation == true) {
			// this.getAnanlyticalSummary();
			this.getPageSummary();
		}
	}

	show_analysis: boolean = false;
	analysis_data: any;
	showAnalysis() {
		if (this.show_analysis == true) {

			let role: any = "";
			if (this.user_details.role.role == 4) {
				role = "Advisor Manager";
			} else if (this.user_details.role.role == 5) {
				role = "Advisor";
			} else if (this.user_details.role.role == 6) {
				role = "AFA";
			} else if (this.user_details.role.role == 8) {
				role = "Relationship Manager";
			}

			this.commonService.getData("/salesprocessanalysis/?role=" + role + "&opp_type=Opportunity" + "&opp_year=" + this.selected_opportunity_period).subscribe(
				(res: any) => {
					this.analysis_data = res;
					setTimeout(() => {
						this.createBreakdownChart();
						this.createRuleBasedBreakdownGraph();
						this.createAITrriggerBreakdownGraph();
					}, 200);
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}

	// opp_breakdown_id: any = "";
	// opp_breakdown_name: any = "";
	createBreakdownChart() {
		let $this = this;
		const options = {
			colors: $this.analysis_data["donout_graph"]["colors"],
			series: $this.analysis_data["donout_graph"]["data"],
			chart: {
				type: 'donut',
				events: {
					// mounted: function(chartContext, config) {
					// 	setTimeout(() => {
					// 		const svgNS = "http://www.w3.org/2000/svg";
					// 		const svgElement = chartContext.el.querySelector('.apexcharts-svg');
					// 		const rect = svgElement.getBoundingClientRect();

					// 		// Dynamically calculate the center based on the SVG dimensions
					// 		const centerX = rect.width / 2;
					// 		const centerY = rect.height / 2;

					// 		chartContext.w.config.series.forEach((value, i) => {
					// 			const angle = (i / chartContext.w.config.series.length) * 2 * Math.PI; // Simplified; for evenly spaced circles
					// 			const radius = Math.min(centerX, centerY) * 0.75; // 75% towards the edge of the SVG
					// 			const x = centerX + radius * Math.cos(angle);
					// 			const y = centerY + radius * Math.sin(angle);

					// 			// Create and append the circle
					// 			let circle = document.createElementNS(svgNS, "circle");
					// 			circle.setAttribute("cx", x.toString());
					// 			circle.setAttribute("cy", y.toString());
					// 			circle.setAttribute("r", "30"); // Circle radius
					// 			circle.setAttribute("fill", "white");
					// 			// circle.setAttribute("fill", $this.analysis_data["donout_graph"]["colors"][i]);
					// 			circle.setAttribute("stroke", "#D3D3D3");
					// 			// circle.setAttribute("stroke", "#FFFFFF");
					// 			circle.setAttribute("stroke-width", "1");
					// 			// circle.setAttribute("stroke-width", "2");
					// 			svgElement.appendChild(circle);

					// 			// Create and append the text, adjust as needed
					// 			let text = document.createElementNS(svgNS, "text");
					// 			text.setAttribute("x", x.toString());
					// 			text.setAttribute("y", (y + 5).toString()); // Slightly offset for text alignment
					// 			text.setAttribute("text-anchor", "middle");
					// 			text.setAttribute("alignment-baseline", "middle");
					// 			text.setAttribute("fill", "black");
					// 			text.textContent = $this.commonService.abbreviateNumber(value).toString();
					// 			svgElement.appendChild(text);
					// 		});
					// 	}, 100); // Delay to ensure chart is fully rendered
					// },
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							id: $this.analysis_data["donout_graph"]['labels'][config.dataPointIndex],
							name: $this.analysis_data["donout_graph"]['labels'][config.dataPointIndex],
						};
						$this.opp_breakdown_id = details.id;
						$this.opp_breakdown_name = details.name;

						$this.current_pagination_page = 1;
						$this.getTableData();

					},
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 400,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			plotOptions: {
				pie: {
					// startAngle: 180,
					// endAngle: -180,
					donut: {
						size: '65%',
						labels: {
							show: true,
							total: {
								show: true,
								showAlways: true,
								label: 'Total',
								fontSize: '14px',
								fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
								fontWeight: 400,
								color: '#000000',
								formatter: function (w) {
									// Calculate the total value
									const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
									// Custom label to display
									return `${(total.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT))}`;
								}
							}
						}
					}
				}
			},
			dataLabels: {
				enabled: true,
				formatter(val, opts) {
					const data = $this.commonService.abbreviateNumber(opts.w.globals.series[opts.seriesIndex])
					return [data]
				},
			},
			labels: $this.analysis_data["donout_graph"]["labels"],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
					formatter: function (value) {
						// let val: string | number = Math.abs(value);
						// if (val >= 10 ** 3 && val < 10 ** 6) {
						// 	val = (val / 1000).toFixed(0) + 'K';
						// } else if (val >= 10 ** 6) {
						// 	val = (val / 1000000).toFixed(0) + 'M';
						// } else {
						// 	val = val;
						// }
						// return val;
						// return value.toLocaleString();
						return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
					},
				},
			},
		};
		var chart = new ApexCharts(document.querySelector("#breakdown-graph"), options);
		chart.render();
	}

	// rules_breakdown_id: any =  "";
	// rules_breakdown_name: any =  "";
	createRuleBasedBreakdownGraph() {
		let $this = this;
		var options = {
			colors: $this.analysis_data["rulebasedtree_graph"]["colors"],
			series: [
				{
					data: $this.analysis_data["rulebasedtree_graph"]["data"]
				}
		  	],
			dataLabels: {
				enabled: true,
				style: {
					colors: ['#000000'] // Specify your desired text color here
				},
			},
			legend: {
				show: false
			},
			chart: {
				height: 350,
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: true,
				},
				type: 'treemap',
				events: {
					dataPointSelection: function(event, chartContext, config) {
						const details = {
							id: $this.analysis_data["rulebasedtree_graph"]['data'][config.dataPointIndex]['id'],
							name: $this.analysis_data["rulebasedtree_graph"]['data'][config.dataPointIndex]['x'],
						};
						$this.rules_breakdown_id = details.id;
						$this.rules_breakdown_name = details.name;

						$this.current_pagination_page = 1;
						$this.getTableData();

					}
				}
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			title: {
				text: ''
			},
			tooltip: {
				// y: {
				//   formatter: function (val) {
				//     return val
				//   }
				// }
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					return (
						'<div style="width:300px; padding:8px">' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['x'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Count:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['y'].toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Condition:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['condition'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['description'] +
						'</p>' +
						'</div>'
					);
				},
				// fixed: {
				// 	enabled: true,
				// 	position: "topRight"
				// }
			},
		};

		var chart = new ApexCharts(document.querySelector("#rule-based-breakdown-graph"), options);
		chart.render();
	}

	// ai_breakdown_id: any =  "";
	// ai_breakdown_name: any =  "";
	createAITrriggerBreakdownGraph() {
		let $this = this;
		var options = {
			colors: $this.analysis_data["aibasedtree_graph"]["colors"],
			series: [
				{
					data: $this.analysis_data["aibasedtree_graph"]["data"]
				}
		  	],
			dataLabels: {
				enabled: true,
				style: {
					colors: ['#000000'] // Specify your desired text color here
				},
			},
			legend: {
				show: false
			},
			chart: {
				height: 350,
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				type: 'treemap',
				events: {
					dataPointSelection: function(event, chartContext, config) {
						const details = {
							id: $this.analysis_data["aibasedtree_graph"]['data'][config.dataPointIndex]['id'],
							name: $this.analysis_data["aibasedtree_graph"]['data'][config.dataPointIndex]['x'],
						};
						$this.ai_breakdown_id = details.id;
						$this.ai_breakdown_name = details.name;

						$this.current_pagination_page = 1;
						$this.getTableData();

					}
				}
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			title: {
				text: ''
			},
			tooltip: {
				// y: {
				//   formatter: function (val) {
				//     return val
				//   }
				// }
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					return (
						'<div style="width:300px; padding:8px">' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['x'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Count:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['y'].toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['description'] +
						'</p>' +
						'</div>'
					);
				},
				// fixed: {
				// 	enabled: true,
				// 	position: "topRight"
				// }
			},
		};

		var chart = new ApexCharts(document.querySelector("#ai-triggers-breakdown-graph"), options);
		chart.render();
	}

	opp_year_name: any = '';
	opp_year_id: any = '';
	createOppYearGraph() {
		let $this = this;
		var options = {
		// colors: ["#5EDEC7"],
		series: [
			{
				name: '',
				data: $this.page_summary_data['yearly_opp']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_summary_data['yearly_opp']['x-axis'][
					config.dataPointIndex
				],
				name: $this.page_summary_data['yearly_opp']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.opp_year_id =
				$this.opp_year_id == details.id ? '' : details.id;
				$this.opp_year_name =
				$this.opp_year_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 280,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('opp-year-graph').clientWidth,
				$this.page_summary_data['yearly_opp']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			// dataLabels: {
			//   position: 'bottom'
			// },
			},
		},
		dataLabels: {
			enabled: false,
			textAnchor: 'start',
			style: {
			colors: ['#000000'],
			fontWeight: '200',
			},
			formatter: function (val, opt) {
			return opt.w.globals.labels[opt.dataPointIndex];
			},
			offsetX: 0,
			dropShadow: {
			enabled: false,
			},
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			categories: $this.page_summary_data['yearly_opp']['x-axis'],
			title: {
			// text: 'Age Range'
			},
			crosshairs: {
			show: false,
			},
		},
		yaxis: {
			labels: {
			show: false,
			},
		},
		fill: {
			opacity: 1,
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#opp-year-graph'),
		options,
		);
		chart.render();
	}

	createCommunicationChannelActivityGraph() {
		// let $this = this;
		// var options = {
		//   // colors: ["#D3D3D3", "#55A1EF"],
		// //   colors: ['#1B82EC', '#FFA724', '#91C906'],
		//   series: $this.page_summary_data['activity_comms']['y-axis'],
		//   chart: {
		// 	type: 'bar',
		// 	toolbar: {
		// 	  show: false,
		// 	},
		// 	zoom: {
		// 	  enabled: false,
		// 	},
		// 	height: 300,
		//   },
		//   noData: {
		// 	text: 'No Data Available',
		// 	align: 'center',
		// 	verticalAlign: 'middle',
		// 	offsetX: 0,
		// 	offsetY: 0,
		// 	style: {
		// 	  color: '#006AFF',
		// 	  fontSize: '24px',
		// 	  fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
		// 	},
		//   },
		//   plotOptions: {
		// 	bar: {
		// 	  horizontal: false,
		// 	  columnWidth: $this.commonService.getBarGraphPercentWidth(
		// 		document.getElementById('communication-channel-activities-graph').clientWidth,
		// 		$this.page_summary_data['activity_comms']['x-axis'].length,
		// 		30,
		// 	  ),
		// 	  endingShape: 'rounded',
		// 	},
		//   },
		//   dataLabels: {
		// 	enabled: false,
		//   },
		//   stroke: {
		// 	show: true,
		// 	width: 2,
		// 	colors: ['transparent'],
		//   },
		//   xaxis: {
		// 	categories: $this.page_summary_data['activity_comms']['x-axis'],
		// 	title: {
		// 	  text: '',
		// 	},
		// 	crosshairs: {
		// 	  show: false,
		// 	},
		//   },
		//   yaxis: {
		// 	title: {
		// 	  text: 'Amount',
		// 	},
		// 	labels: {
		// 	  formatter: function (value) {
		// 		let val: string | number = Math.abs(value);
		// 		if (val >= 10 ** 3 && val < 10 ** 6) {
		// 		  val = (val / 1000).toFixed(0) + 'K';
		// 		} else if (val >= 10 ** 6) {
		// 		  val = (val / 1000000).toFixed(0) + 'M';
		// 		} else {
		// 		  val = val;
		// 		}
		// 		return val;
		// 	  },
		// 	},
		//   },
		//   fill: {
		// 	opacity: 1,
		//   },
		//   tooltip: {
		// 	y: {
		// 	  formatter: function (value) {
		// 		let val: string | number = Math.abs(value);
		// 		if (val >= 10 ** 3 && val < 10 ** 6) {
		// 		  val = (val / 1000).toFixed(0) + 'K';
		// 		} else if (val >= 10 ** 6) {
		// 		  val = (val / 1000000).toFixed(0) + 'M';
		// 		} else {
		// 		  val = val;
		// 		}
		// 		return val;
		// 	  },
		// 	},
		//   },
		// };

		// var chart = new ApexCharts(document.querySelector('#communication-channel-activities-graph'), options);
		// chart.render();

		let $this = this;
		let label_colors: any = [];

		for (let index = 0; index < $this.page_summary_data['radar_chart']["x-axis"].length; index++) {
			label_colors.push("#000000");
		}

		var options = {
			colors: $this.page_summary_data['radar_chart']['colors'],
			series: [{
				name: '',
				data: $this.page_summary_data['radar_chart']["y-axis"],
				// data: [10, 20, 30, 10, 40, 66, 11, 33, 22, 77],
			}],
			chart: {
				type: 'radar',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 280,
			},
			plotOptions: {
				radar: {
				  size: 140,
				  offsetX: 0,
				  offsetY: 10,
				  polygons: {
					strokeColors: '#858a90',
					strokeWidth: 1,
					connectorColors: '#858a90',
					// fill: {
					// 	colors: ['#f8f8f8', '#fff']
					// }
				  }
				}
			  },
			title: {
				text: ''
			},
			yaxis: {
				// stepSize: 20
			},
			xaxis: {
				categories: $this.page_summary_data['radar_chart']["x-axis"],
				labels: {
					style: {
					//   colors: $this.page_summary_data['radar_chart']['colors']
					  colors: label_colors
					},
				},
			},
		};

		var chart = new ApexCharts(document.querySelector("#communication-channel-activities-graph"), options);
		chart.render();
	}

	createMonthlyActivityGraph() {
		let $this = this;
		var options = {
		  // colors: ["#D3D3D3", "#55A1EF"],
		//   colors: ['#1B82EC', '#FFA724', '#91C906'],
		  series: $this.page_summary_data['activity_months']['y-axis'],
		  chart: {
			type: 'bar',
			toolbar: {
			  show: false,
			},
			zoom: {
			  enabled: false,
			},
			height: 280,
		  },
		  noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			  color: '#006AFF',
			  fontSize: '24px',
			  fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		  },
		  plotOptions: {
			bar: {
			  horizontal: false,
			  columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('monthly-activities-graph').clientWidth,
				$this.page_summary_data['activity_months']['x-axis'].length,
				30,
			  ),
			  endingShape: 'rounded',
			},
		  },
		  dataLabels: {
			enabled: false,
		  },
		  stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		  },
		  xaxis: {
			categories: $this.page_summary_data['activity_months']['x-axis'],
			title: {
			  text: '',
			},
			crosshairs: {
			  show: false,
			},
		  },
		  yaxis: {
			title: {
			  text: 'Amount',
			},
			labels: {
			  // formatter: function (value) {
				// let val: string | number = Math.abs(value);
				// if (val >= 10 ** 3 && val < 10 ** 6) {
				//   val = (val / 1000).toFixed(0) + 'K';
				// } else if (val >= 10 ** 6) {
				//   val = (val / 1000000).toFixed(0) + 'M';
				// } else {
				//   val = val;
				// }
				// return val;
			  // },
        formatter: (value: number) => {
          return this.commonService.labelFormatter(value);
        }
			},
		  },
		  fill: {
			opacity: 1,
		  },
		  tooltip: {
			y: {
			  // formatter: function (value) {
				// let val: string | number = Math.abs(value);
				// if (val >= 10 ** 3 && val < 10 ** 6) {
				//   val = (val / 1000).toFixed(0) + 'K';
				// } else if (val >= 10 ** 6) {
				//   val = (val / 1000000).toFixed(0) + 'M';
				// } else {
				//   val = val;
				// }
				// return val;
			  // },
        formatter: (value: number) => {
          return this.commonService.labelFormatter(value);
        }
			},
		  },
		};

		var chart = new ApexCharts(document.querySelector('#monthly-activities-graph'), options);
		chart.render();
	}

	upside_opportunity_name: any = '';
	upside_opportunity_id: any = '';
	getUpsideOpportunityGraph() {
		let $this = this;

			const options = {
				colors: $this.page_summary_data["upside_graph"]['colors'],
				series: $this.page_summary_data["upside_graph"]['data'],
				chart: {
					// type: 'bar',
					type: 'donut',
					events: {
						dataPointSelection: function (event, chartContext, config) {
							const details = {
							id: $this.page_summary_data['upside_graph']['labels'][config.dataPointIndex],
							name: $this.page_summary_data['upside_graph']['labels'][config.dataPointIndex],
							};
							$this.upside_opportunity_id = $this.upside_opportunity_id == details.id ? '' : details.id;
							$this.upside_opportunity_name = $this.upside_opportunity_name == details.name ? '' : details.name;
							$this.current_pagination_page = 1;
							$this.getTableData();
						},
					},
					toolbar: {
						show: false,
					},
					zoom: {
						enabled: false,
					},
					height: 328,
				},
				noData: {
					text: 'No Data Available',
					align: 'center',
					verticalAlign: 'middle',
					offsetX: 0,
					offsetY: 0,
					style: {
						color: '#006AFF',
						fontSize: '24px',
						fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
					},
				},
				plotOptions: {
					pie: {
						startAngle: 0
					}
				},
				dataLabels: {
					enabled: false,
				},
				labels: $this.page_summary_data["upside_graph"]['labels'],
				legend: {
					position: 'bottom',
					enabled: false,
				},
				yaxis: {
					title: {
						text: '',
					},
				},
				fill: {
					opacity: 1,
				},
			};

		var chart = new ApexCharts(
		document.querySelector('#upside-opportunity-graph'),
		options,
		);
		chart.render();

	}

	age_trigger_name: any = '';
	age_trigger_id: any = '';
	createAgeTriggerGraph() {
		let $this = this;
		var options = {
		// colors: ["#5EDEC7"],
		series: [
			{
				name: '',
				data: $this.page_summary_data['clients_by_age']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_summary_data['clients_by_age']['labels'][
					config.dataPointIndex
				],
				name: $this.page_summary_data['clients_by_age']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.age_trigger_id =
				$this.age_trigger_id == details.id ? '' : details.id;
				$this.age_trigger_name =
				$this.age_trigger_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 280,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('age-triggers-graph').clientWidth,
				$this.page_summary_data['clients_by_age']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			// dataLabels: {
			//   position: 'bottom'
			// },
			},
		},
		dataLabels: {
			enabled: false,
			textAnchor: 'start',
			style: {
			colors: ['#000000'],
			fontWeight: '200',
			},
			formatter: function (val, opt) {
			return opt.w.globals.labels[opt.dataPointIndex];
			},
			offsetX: 0,
			dropShadow: {
			enabled: false,
			},
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			// categories: $this.page_summary_data['clients_by_age']['codes'],
			categories: $this.page_summary_data['clients_by_age']['x-axis'],
			title: {
			// text: 'Age Range'
			},
			crosshairs: {
			show: false,
			},
		},
		yaxis: {
			labels: {
			show: false,
			},
		},
		fill: {
			opacity: 1,
		},
		tooltip: {
			// y: {
			//   formatter: function (val) {
			//     return val
			//   }
			// }
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			return (
				'<div style="width:250px; padding:8px">' +
				// '<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Age</b>: ' +
				// $this.page_summary_data['clients_by_age']['x-axis'][dataPointIndex] +
				// '</p>' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name</b>: ' +
				$this.page_summary_data['clients_by_age']['legends'][dataPointIndex] +
				'</p>' +
				'<p><b>Value</b>: ' +
				$this.page_summary_data['clients_by_age']['y-axis'][dataPointIndex] +
				'</p>' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description</b>: ' +
				$this.page_summary_data['clients_by_age']['description'][dataPointIndex] +
				'</p>' +
				'</div>'
			);
			},
			//  fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#age-triggers-graph'),
		options,
		);
		chart.render();
	}

	date_trigger_name: any = '';
	date_trigger_id: any = '';
	createDateTriggerGraph() {
		let $this = this;
		var options = {
		// colors: "#D3D3D3",
		series: [
			{
				name: '',
				data: $this.page_summary_data['clients_by_date']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_summary_data['clients_by_date']['labels'][
					config.dataPointIndex
				],
				name: $this.page_summary_data['clients_by_date']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.date_trigger_id =
				$this.date_trigger_id == details.id ? '' : details.id;
				$this.date_trigger_name =
				$this.date_trigger_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 280,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('date-triggers-graph').clientWidth,
				$this.page_summary_data['clients_by_date']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			// dataLabels: {
			//   position: 'bottom'
			// },
			},
		},
		dataLabels: {
			enabled: false,
			textAnchor: 'start',
			style: {
			colors: ['#000000'],
			fontWeight: '200',
			},
			formatter: function (val, opt) {
			return opt.w.globals.labels[opt.dataPointIndex];
			},
			offsetX: 0,
			dropShadow: {
			enabled: false,
			},
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			categories: $this.page_summary_data['clients_by_date']['codes'],
			title: {
			// text: 'Age Range'
			},
			crosshairs: {
			show: false,
			},
		},
		yaxis: {
			labels: {
			show: false,
			},
		},
		fill: {
			opacity: 1,
		},
		tooltip: {
			// y: {
			//   formatter: function (val) {
			//     return val
			//   }
			// }
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			return (
				'<div style="width:250px; padding:8px">' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name</b>: ' +
				$this.page_summary_data['clients_by_date']['legends'][dataPointIndex] +
				'</p>' +
				'<p><b>Value</b>: ' +
				$this.page_summary_data['clients_by_date']['y-axis'][dataPointIndex] +
				'</p>' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description</b>: ' +
				$this.page_summary_data['clients_by_date']['description'][dataPointIndex] +
				'</p>' +
				'</div>'
			);
			},
			//  fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#date-triggers-graph'),
		options,
		);
		chart.render();
	}

	data_trigger_name: any = '';
	data_trigger_id: any = '';
	createDataTriggerGraph() {
		let $this = this;
		var options = {
		// colors: "#D3D3D3",
		series: [
			{
			name: '',
			data: $this.page_summary_data['clients_by_data']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_summary_data['clients_by_data']['labels'][
					config.dataPointIndex
				],
				name: $this.page_summary_data['clients_by_data']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.data_trigger_id =
				$this.data_trigger_id == details.id ? '' : details.id;
				$this.data_trigger_name =
				$this.data_trigger_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 280,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('data-triggers-graph').clientWidth,
				$this.page_summary_data['clients_by_data']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			// dataLabels: {
			//   position: 'bottom'
			// },
			},
		},
		dataLabels: {
			enabled: false,
			textAnchor: 'start',
			style: {
			colors: ['#000000'],
			fontWeight: '200',
			},
			formatter: function (val, opt) {
			return opt.w.globals.labels[opt.dataPointIndex];
			},
			offsetX: 0,
			dropShadow: {
			enabled: false,
			},
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			categories: $this.page_summary_data['clients_by_data']['codes'],
			title: {
			// text: 'Age Range'
			},
			crosshairs: {
			show: false,
			},
		},
		yaxis: {
			labels: {
			show: false,
			},
		},
		fill: {
			opacity: 1,
		},
		tooltip: {
			// y: {
			//   formatter: function (val) {
			//     return val
			//   }
			// }
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			return (
				'<div style="width:250px; padding:8px">' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name</b>: ' +
				$this.page_summary_data['clients_by_data']['legends'][dataPointIndex] +
				'</p>' +
				'<p><b>Value</b>: ' +
				$this.page_summary_data['clients_by_data']['y-axis'][dataPointIndex] +
				'</p>' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description</b>: ' +
				$this.page_summary_data['clients_by_data']['description'][dataPointIndex] +
				'</p>' +
				'</div>'
			);
			},
			//  fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#data-triggers-graph'),
		options,
		);
		chart.render();
	}

  	ai_trigger_name: any = '';
	ai_trigger_id: any = '';
	createAITriggerGraph() {
		let $this = this;
		var options = {
		// colors: "#D3D3D3",
		series: [
			{
			name: '',
			data: $this.page_summary_data['clients_by_ai']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_summary_data['clients_by_ai']['labels'][
					config.dataPointIndex
				],
				name: $this.page_summary_data['clients_by_ai']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.ai_trigger_id =
				$this.ai_trigger_id == details.id ? '' : details.id;
				$this.ai_trigger_name =
				$this.ai_trigger_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 280,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('ai-triggers-graph').clientWidth,
				$this.page_summary_data['clients_by_ai']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			// dataLabels: {
			//   position: 'bottom'
			// },
			},
		},
		dataLabels: {
			enabled: false,
			textAnchor: 'start',
			style: {
			colors: ['#000000'],
			fontWeight: '200',
			},
			formatter: function (val, opt) {
			return opt.w.globals.labels[opt.dataPointIndex];
			},
			offsetX: 0,
			dropShadow: {
			enabled: false,
			},
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			categories: $this.page_summary_data['clients_by_ai']['x-axis'],
			title: {
			// text: 'Age Range'
			},
			crosshairs: {
			show: false,
			},
		},
		yaxis: {
			labels: {
			show: false,
			},
		},
		fill: {
			opacity: 1,
		},
		tooltip: {
			// y: {
			//   formatter: function (val) {
			//     return val
			//   }
			// }
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			return (
				'<div style="width:250px; padding:8px">' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name</b>: ' +
				$this.page_summary_data['clients_by_ai']['x-axis'][dataPointIndex] +
				'</p>' +
				'<p><b>Value</b>: ' +
				$this.page_summary_data['clients_by_ai']['y-axis'][dataPointIndex] +
				'</p>' +
				'</div>'
			);
			},
			//  fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#ai-triggers-graph'),
		options,
		);
		chart.render();
	}

	client_value_name: any = '';
	client_value_id: any = '';
	createClientValueGraph() {
		let $this = this;
		var options = {
		// colors: "#D3D3D3",
		series: [
			{
			name: '',
			data: $this.page_summary_data['clients_by_value']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_summary_data['clients_by_value']['ids'][
					config.dataPointIndex
				],
				name: $this.page_summary_data['clients_by_value']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.client_value_id =
				$this.client_value_id == details.id ? '' : details.id;
				$this.client_value_name =
				$this.client_value_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 280,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('value-clients-graph').clientWidth,
				$this.page_summary_data['clients_by_value']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			},
		},
		dataLabels: {
			enabled: false,
		},
		// stroke: {
		//   show: true,
		//   width: 2,
		//   colors: ['transparent']
		// },
		xaxis: {
			categories: $this.page_summary_data['clients_by_value']['x-axis'],
			title: {
			// text: 'Value'
			},
			crosshairs: {
			show: false,
			},
		},
		legend: {
			position: 'bottom',
		},
		yaxis: {
			title: {
			text: 'Count',
			},
		},
		fill: {
			opacity: 1,
		},
		tooltip: {
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			var data =
				$this.page_summary_data['clients_by_value']['tooltip'][dataPointIndex];
			var count =
				$this.page_summary_data['clients_by_value']['y-axis'][dataPointIndex];
			data = 'Predicted AUM: $' + data.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) + '<br>';
			count = 'Count : ' + count;
			return data + count;
			},
			// fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		// tooltip: {
		//   y: {
		//     formatter: function (val) {
		//       return val
		//     }
		//   }
		// }
		};

		var chart = new ApexCharts(
		document.querySelector('#value-clients-graph'),
		options,
		);
		chart.render();
	}

	client_closure_name: any = '';
	client_closure_id: any = '';
	createClientClosureGraph() {
		let $this = this;
		var options = {
		// colors: "#D3D3D3",
		series: [
			{
			name: '',
			data: $this.page_summary_data['clients_by_time']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_summary_data['clients_by_time']['ids'][
					config.dataPointIndex
				],
				name: $this.page_summary_data['clients_by_time']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.client_closure_id =
				$this.client_closure_id == details.id ? '' : details.id;
				$this.client_closure_name =
				$this.client_closure_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 280,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('closure-time-clients-graph').clientWidth,
				$this.page_summary_data['clients_by_time']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			},
		},
		dataLabels: {
			enabled: false,
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			categories: $this.page_summary_data['clients_by_time']['x-axis'],
			title: {
			// text: 'Value'
			},
			crosshairs: {
			show: false,
			},
		},
		yaxis: {
			title: {
			text: 'Count',
			},
		},
		fill: {
			opacity: 1,
		},
		tooltip: {
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			var data =
				$this.page_summary_data['clients_by_time']['tooltip'][dataPointIndex];
			var count =
				$this.page_summary_data['clients_by_time']['y-axis'][dataPointIndex];
			data = 'Predicted AUM: $' + data.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) + '<br>';
			count = 'Count: ' + count;
			return data + count;
			},
			// fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#closure-time-clients-graph'),
		options,
		);
		chart.render();
	}

	createClientValueClosureGraph() {
		let $this = this;
		var options = {
		series: $this.page_summary_data['clients_by_both'],
		colors: ['#008FFB'],
		chart: {
			height: 280,
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			type: 'heatmap',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				// const details = {
				//   value: $this.page_summary_data["clients_by_both"][config.seriesIndex].data[config.dataPointIndex].x,
				//   value_id: $this.page_summary_data["clients_by_both"][config.seriesIndex].time_ids,
				//   closure: $this.page_summary_data["clients_by_both"][config.seriesIndex].name,
				//   closure_id: $this.page_summary_data["clients_by_both"][config.seriesIndex].data[config.dataPointIndex].value_ids,
				// };

				const details = {
				value:
					$this.page_summary_data['clients_by_both'][config.seriesIndex].data[
					config.dataPointIndex
					].x,
				value_id:
					$this.page_summary_data['clients_by_both'][config.seriesIndex].data[
					config.dataPointIndex
					].value_ids,
				closure:
					$this.page_summary_data['clients_by_both'][config.seriesIndex].name,
				closure_id:
					$this.page_summary_data['clients_by_both'][config.seriesIndex].time_ids,
				};
				// $this.client_value_id = $this.client_value_id == details.value_id ? "" : details.value_id;
				// $this.client_value_name = $this.client_value_name == details.value ? "" : details.value;
				// $this.client_closure_id = $this.client_closure_id == details.closure_id ? "" : details.closure_id;
				// $this.client_closure_name = $this.client_closure_name == details.closure ? "" : details.closure;

				$this.client_value_id = details.value_id;
				$this.client_value_name = details.value;
				$this.client_closure_id = details.closure_id;
				$this.client_closure_name = details.closure;

				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			heatmap: {
			shadeIntensity: 0.5,
			radius: 0,
			useFillColorAsStroke: false,
			// colorScale: {
			//   ranges: [{
			//       from: -30,
			//       to: 5,
			//       name: 'low',
			//       color: '#00A100'
			//     },
			//     {
			//       from: 6,
			//       to: 20,
			//       name: 'medium',
			//       color: '#128FD9'
			//     },
			//     {
			//       from: 21,
			//       to: 45,
			//       name: 'high',
			//       color: '#FFB200'
			//     },
			//     {
			//       from: 46,
			//       to: 55,
			//       name: 'extreme',
			//       color: '#FF0000'
			//     }
			//   ]
			// }
			},
		},
		dataLabels: {
			enabled: false,
		},
		stroke: {
			width: 1,
		},
		title: {
			// text: 'HeatMap Chart with Color Range'
			text: '',
		},
		tooltip: {
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			var closure_value =
				'Value: ' +
				$this.page_summary_data['clients_by_both'][seriesIndex].data[dataPointIndex]
				.x +
				'<br>';
			var closure_time =
				'Closure time: ' +
				$this.page_summary_data['clients_by_both'][seriesIndex].name +
				'<br>';
			var count =
				'Count: ' +
				$this.page_summary_data['clients_by_both'][seriesIndex].data[dataPointIndex]
				.y;
			return closure_value + closure_time + count;
			},
			// fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#value-closure-clients-graph'),
		options,
		);
		chart.render();

		// let $this = this;
		// var options = {
		//   series: $this.page_summary_data["clients_by_both"],
		//   chart: {
		//     height: 280,
		//     type: 'scatter',
		//     // events: {
		//     //   dataPointSelection: function (event, chartContext, config) {
		//     //     const details = {
		//     //       value: $this.page_summary_data["clients_by_both"][config.seriesIndex]["data"][config.dataPointIndex][0],
		//     //       closure: $this.page_summary_data["clients_by_both"][config.seriesIndex]["data"][config.dataPointIndex][1],
		//     //     };
		//     //     $this.client_value_id = $this.client_value_id == details.value ? "" : details.value;
		//     //     $this.client_value_name = $this.client_value_name == details.value ? "" : details.value;
		//     //     $this.client_closure_id = $this.client_value_id == details.closure ? "" : details.closure;
		//     //     $this.client_closure_name = $this.client_value_name == details.closure ? "" : details.closure;
		//     //     $this.current_pagination_page = 1;
		//     //     $this.getClientsData();
		//     //   }
		//     // },
		//     toolbar: {
		//       show: false
		//     },
		//     zoom: {
		//       enabled: false,
		//       type: 'xy'
		//     }
		//   },
		//   xaxis: {
		//     tickAmount: 5,
		//     labels: {
		//       formatter: function(val) {
		//         return parseFloat(val).toFixed(1)
		//       }
		//     }
		//   },
		//   yaxis: {
		//     // tickAmount: 7
		//   }
		// };

		// var chart = new ApexCharts(document.querySelector("#value-closure-clients-graph"), options);
		// chart.render();
	}

	search_key: any = '';

	current_pagination_page = 1;
	total_pagination_records = 0;
	pagination_records_limit: any = 10;

	selected_alphabet = '';
	alphabets_array = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',];
	show_search: boolean = false;
	table_columns: any = [];
	table_data: any = [];
	selected_table_data: any = [];
	table_data_loaded: boolean = false;
	show_toggle_columns: boolean = false;
	getTableData() {

		this.show_activity_view = null;

		this.selected_client = {
			id: ""
		};
		this.table_data_loaded = false;

		// let route: any = "/client?records_per_page=" + this.pagination_records_limit + "&search=" + this.search_key + "&alphabet=" + this.selected_alphabet + "&page=" + this.current_pagination_page + "&advisor=" + this.user_details.id + "&clients_by_age_trigger=" + this.age_trigger_id + "&clients_by_date_trigger=" + this.date_trigger_id + "&clients_by_data_trigger=" + this.data_trigger_id + "&clients_by_csvalue=" + this.client_value_id + "&clients_by_csdays=" + this.client_closure_id + "&duration=" + this.selected_opportunity_period + "&stage=Follow Up";

		// let type: any = "";
		// if (this.type == "Total Opportunities") {
		// 	if (this.selected_sale_type == "all") {
		// 		type = "Total Opportunities"
		// 	} else {
		// 		type = this.selected_sale_type;
		// 	}
		// } else if (this.type == "Up-Sell Opportunities") {
		// 	type = "Up-Sell Opportunities";
		// } else if (this.type == "Cross-Sell Opportunities") {
		// 	type = "Cross-Sell Opportunities";
		// }

		// let route: any = "/salesprocessopportunitytableupdated/" + this.selected_top_percentage + "/" + this.selected_high_value_leads + "/" + this.selected_analysis_value + "/" + this.type + "/" + this.current_pagination_page + "/" + "?records_per_page=" + this.pagination_records_limit + "&search=" + this.search_key + "&duration=" + this.selected_opportunity_period + "&clients_by_age_trigger=" + this.age_trigger_id + "&clients_by_date_trigger=" + this.date_trigger_id + "&clients_by_data_trigger=" + this.data_trigger_id + "&clients_by_csvalue=" + this.client_value_id + "&clients_by_csdays=" + this.client_closure_id + '&clients_by_upside_opportunity=' + this.upside_opportunity_id;

		let route: any = "/salesprocessopportunitytableupdated/" + this.selected_top_percentage + "/" + this.selected_high_value_leads + "/" + this.selected_analysis_value + "/" + this.type + "/" + this.current_pagination_page + "/" + "?records_per_page=" + this.pagination_records_limit + "&search=" + this.search_key + "&duration=" + this.selected_opportunity_period + "&clients_by_age_trigger=" + this.age_trigger_id + "&clients_by_date_trigger=" + this.date_trigger_id + "&clients_by_data_trigger=" + this.data_trigger_id + "&clients_by_ai_trigger=" + this.ai_trigger_id + "&clients_by_opportunity=" + this.client_value_id + "&clients_by_days=" + this.client_closure_id + '&clients_by_upside_opportunity=' + this.upside_opportunity_id + '&clients_by_analysis_opportunity=' + this.opp_breakdown_id + '&clients_by_rulebased_trigger=' + this.rules_breakdown_id + '&clients_by_aibased_trigger=' + this.ai_breakdown_id + '&clients_by_both_trigger=' + this.common_breakdown_id;

    if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
      route = "/magiclienttableupdated/" + this.selected_top_percentage + "/" + this.selected_high_value_leads + "/" + this.selected_analysis_value + "/" + this.type + "/" + this.current_pagination_page + "/" + "?records_per_page=" + this.pagination_records_limit + "&search=" + this.search_key + "&duration=" + this.selected_opportunity_period + "&clients_by_age_trigger=" + this.age_trigger_id + "&clients_by_date_trigger=" + this.date_trigger_id + "&clients_by_data_trigger=" + this.data_trigger_id + "&clients_by_ai_trigger=" + this.ai_trigger_id + "&clients_by_opportunity=" + this.client_value_id + "&clients_by_days=" + this.client_closure_id + '&clients_by_upside_opportunity=' + this.upside_opportunity_id + '&clients_by_analysis_opportunity=' + this.opp_breakdown_id + '&clients_by_rulebased_trigger=' + this.rules_breakdown_id + '&clients_by_aibased_trigger=' + this.ai_breakdown_id + '&clients_by_both_trigger=' + this.common_breakdown_id;
    }

    http://localhost:8004/api/v1/deposits/magiclienttableupdated/100/0/100/Upside%20Opportunities/1/?records_per_page=10&search=&duration=next_three_years&clients_by_age_trigger=&clients_by_date_trigger=&clients_by_data_trigger=&clients_by_ai_trigger=&clients_by_opportunity=&clients_by_days=&clients_by_upside_opportunity=&clients_by_analysis_opportunity=&clients_by_rulebased_trigger=&clients_by_aibased_trigger=&clients_by_both_trigger=&opp_year=next_three_years

		if (this.selected_page_action.name == "Capture Response" || this.selected_page_action.name == "Product Information") {
			route = route + "&screen_type=true";
		}

		if (this.opp_year_id != '') {
			route = route + "&yearly_filter=" + this.opp_year_id;
		} else {
			route = route + "&opp_year=" + this.selected_opportunity_period;
		}

		// if (this.type == "Total Opportunities") {
		// 	if (this.selected_sale_type == "all") {

		// 	} else if (this.selected_sale_type == "Up-Sell Opportunities") {
		// 		route = route + "&clients_by_upsell=true";
		// 	} else if (this.selected_sale_type == "Cross-Sell Opportunities") {
		// 		route = route + "&clients_by_crosssell=true";
		// 	}
		// } else if (this.type == "Up-Sell Opportunities") {
		// 	route = route + "&clients_by_upsell=true";
		// } else if (this.type == "Cross-Sell Opportunities") {
		// 	route = route + "&clients_by_crosssell=true";
		// }

		this.commonService.getData(route).subscribe(
			(res: any) => {
        this.table_columns = res['columns'];
        // for (let index = 0; index < this.table_columns.length; index++) {
        if (this.table_columns.length > 0) {
          for (let index = 0; index < 9; index++) {
            this.table_columns[index].checked = true;
          }
        }
				// this.table_data = res['results']['data'];
				this.table_data = res['results'];
				this.current_pagination_page = res.page_number;
				this.total_pagination_records = res.total_no_of_records;
				this.table_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		  );
	}

	pageChanged(event) {

		this.show_activity_view = null;

		this.current_pagination_page = event;
		this.pagination_records_limit = this.pagination_records_limit;
		this.getTableData();
	}

	getTableKey(data, column) {
		const key = column['key'];
		return data[key];
	}

	@ViewChild('clientDataModal') clientDataModal: TemplateRef<any>;
	private clientDataModalRef: MatDialogRef<TemplateRef<any>>;

	selected_modal_client: any;
	selected_modal_client_loader: boolean = false;;
	openClientDataModal(data) {
		this.selected_modal_client_loader = true;
		this.selected_modal_client = JSON.parse(JSON.stringify(data));


		this.clientDataModalRef = this.dialog.open(this.clientDataModal, { disableClose: true });
		this.clientDataModalRef.afterClosed().subscribe((result) => {
			this.closeClientDataModal();
		});

		this.commonService.getData('/customerdetails/?id=' + this.selected_modal_client.id).subscribe(
			(res: any) => {
				this.selected_modal_client = res["data"];
				this.selected_modal_client_loader = false;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	closeClientDataModal() {
		this.selected_modal_client = {};
		this.clientDataModalRef.close();
		this.selected_modal_client_loader = false;
	}

	selected_client:any = {
		id: ""
	};
	selected_client_summary:any = {};
	selected_client_summary_loader:boolean = false;
	selectClient(data) {
		this.selected_client_summary_loader = true;
		this.selected_client = JSON.parse(JSON.stringify(data));
		this.selected_client_summary = {};
		this.commonService.getData("/clientfollowupdetails?id=" + this.selected_client.id).subscribe(
			(res: any) => {
				this.selected_client_summary = res["client_details"];
				this.selected_client_summary_loader = false;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.selected_client_summary_loader = false;
			},
		);
	}

	deSelectClient() {
		this.selected_client = {
			id: ""
		};
	}

	show_opporunity_description: boolean = false;
	show_close_deal_description: boolean = false;
	show_preferred_channel_description: boolean = false;


  show_activity_view: number = null;
  toggleActivityView(value) {
    if (this.show_activity_view == value) {
      this.show_activity_view = null;
    } else {
      this.show_activity_view = value;
    }
  }

  dataChanged(event) {
	this.show_activity_view = null;
    this.getTableData();
    this.changeStepper();
  }

  @Output() stepperChange = new EventEmitter<any>();
  changeStepper() {
    // const data = {
    //   step: 2,
    // };
    // this.stepperChange.emit(data);
    this.stepperChange.emit(this.stepper_stage);
  }

  	opportunity_client: any;
  	@ViewChild('addOpportunityModal') addOpportunityModal: TemplateRef<any>;
	private addOpportunityModalRef: MatDialogRef<TemplateRef<any>>;
	openAddOpportunityModal(data) {
		this.opportunity_client = JSON.parse(JSON.stringify(data));
		this.addOpportunityModalRef = this.dialog.open(
			this.addOpportunityModal, { disableClose: true }
		);
		this.addOpportunityModalRef.afterClosed().subscribe((result) => {
			this.closeAddOpportunityModal();
		});
	}

	closeAddOpportunityModal() {
		this.addOpportunityModalRef.close();
		this.opportunity_client = {};
	}

	addOpportunity() {
		const payload = {
			id: this.opportunity_client.id
		};
		this.commonService.postData("/converttoopportunity/", payload).subscribe(
			(res: any) => {
				this.commonService.showToast('success', 'Client Added to Upside Opportunities Successfully.');
				this.getPageSummary();
				this.closeAddOpportunityModal();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}


	is_selected: boolean = false;
	selectAll(event) {
		if (event.checked == true) {
			this.selected_table_data = JSON.parse(JSON.stringify(this.table_data));
			this.is_selected = true;
		} else {
			this.selected_table_data = [];
			this.is_selected = false;
		}
	}

	checkIndividualSelection(data) {
		const index = this.selected_table_data.findIndex((obj) => obj.id == data.id);
		if (index != -1) {
			return true;
		} else {
			return false;
		}
	}

	selectIndividual(event, data) {
		const index = this.selected_table_data.findIndex((obj) => obj.id == data.id);
		if (index != -1) {
			if (event.checked == true) {
				this.selected_table_data.splice(index, 0, data);
			} else {
				this.selected_table_data.splice(index, 1);
			}
		} else {
			this.selected_table_data.splice(index, 0, data);
		}

		if (this.table_data.length == this.selected_table_data.length) {
			this.is_selected = true;
		} else {
			this.is_selected = false;
		}
	}

	move_record_error: boolean = false;
  	@ViewChild('moveRecordModal') moveRecordModal: TemplateRef<any>;
	private moveRecordModalRef: MatDialogRef<TemplateRef<any>>;
	openMoveRecordModal() {
		if (this.selected_table_data.length > 0) {
			this.moveRecordModalRef = this.dialog.open(this.moveRecordModal, { disableClose: true });
			this.moveRecordModalRef.afterClosed().subscribe((result) => {
				this.closeMoveRecordModal();
			});
			this.move_record_error = false;
		} else {
			this.move_record_error = true;
		}
	}

	closeMoveRecordModal() {
		this.moveRecordModalRef.close();
		this.move_record_error = false;
		this.move_record_stage = "";
		this.move_record_stage_error = false;
	}

	stages_data: any = [];
	getStages() {
		let type: any = "";
		if (this.type == "Upside Opportunities") {
			type = "opportunity";
		} else if (this.type == "Retention Opportunities") {
			type = "retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			type = "new";
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			type = "members";
		} else if (this.type == "Non Customers") {
			type = "non_members";
		}

		this.commonService.getData('/stage?no_page=true&financial_institution=' + this.user_details.financial_institution + '&current_stage=' + this.stepper_stage.id + "&type=" + type + "&business_area=" + this.user_details.role.business_area[0]).subscribe(
			(res: any) => {
				this.stages_data = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	move_record_stage: any = "";
	move_record_stage_error: boolean = false;
	move_record_stage_activity_status: boolean = false;
	changeClientStage() {
		if (this.move_record_stage != "" && this.move_record_stage != null) {
			this.move_record_stage_error = false;
		} else {
			this.move_record_stage_error = true;
		}

		let payload: any = {
			current_stage: this.stepper_stage.id,
			target_stage: this.move_record_stage,
			client_list: [],
			not_required: this.move_record_stage_activity_status,
			type: ""
		};

		if (this.type == "Upside Opportunities") {
			payload.type = "opportunity";
		} else if (this.type == "Retention Opportunities") {
			payload.type = "retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			payload.type = "new";
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			payload.type = "members";
		} else if (this.type == "Non Customers") {
			payload.type = "non_members";
		}

		for (let index = 0; index < this.selected_table_data.length; index++) {
			payload.client_list.push(this.selected_table_data[index].id);
		}

		if (this.move_record_stage_error == false) {
			this.commonService.postData("/movestage/", payload).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Stage Changed Successfully.');
					this.closeMoveRecordModal();
					this.selected_table_data = [];
					this.is_selected = false;
					this.changeStepper();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

	}

	upside_opportunity_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "AI Rank",
					value: "Upside Opportunity is a crucial metric that helps identify the most promising clients for the company. This is a significant factor in the company's strategy for expanding its services. This rank is calculated by employing a sophisticated combination of two AI models: predicted opportunity and the shortest time to close the deal by the advisor. This AI model considers various client-specific attributes, historical transactions, advisor attributes, and macroeconomic variables. By analyzing these data points, the AI model can accurately assess the likelihood of a client churning."
				},
				{
					name: "AI recommendation",
					value: "Two additional AI models work in parallel to identify the optimal products and channels for the clients. These AI models help the advisor to recommend products through preferred channels. The AI model considers various client-specific attributes and historical transactions. By analyzing these data points, the AI model can accurately assess the optimal products and channels."
				},
				{
					name: "Opportunity",
					value: "The objective of this model is to predict the advisor's likelihood to sell. The input variables are demographic variables (client) and macroeconomic variables (market performance). This model works for existing clients as well as new clients (prospects). For the new clients the AUM, Balance, Net worth, Liquid net worth, and Count of products are not captured. These variables are not part of the final model. "
				},
				{
					name: "Shortest time to close",
					value: "This model estimates the shortest time to close the deal. Inputs to the model include customer demographics, transaction history, total investment, advisor experience, advisor certificates & licenses, and advisor states serviced. Relationships are identified between the independent and dependent variables using AI models. The model returns the days it takes to close the deal. "
				},
				{
					name: "Channel and Product",
					value: "Two additional AI models work in parallel to identify the optimal products and channels for the clients. These AI models help the advisor to recommend products through preferred channels. The AI model considers various client-specific attributes and historical transactions. "
				}
			]
		},
	];


	show_user_profile: boolean = false;
    user_profile_data: any;
    showUserProfile(data) {
      this.user_profile_data = JSON.parse(JSON.stringify(data));
      this.show_user_profile = true;
    }

    profileClosed(event) {
      this.user_profile_data = {};
      this.show_user_profile = false;
    }

	rule_based_tooltip_section: any = [
		{
			name: "Rules-Based Triggers have been developed in collaboration with financial advisors, wealth management experts, and industry thought leaders, drawing on the collective experience of these professionals over the past 30 to 40 years."
		},
		{
			name: "This knowledge encompasses how financial advisors and institutions have historically identified new opportunities, cross-selling potentials, and clients who may be at risk of departing. These triggers are adaptable and can be customized to align with the specific internal regulations of any organization."
		}
	];

	ai_based_tooltip_section: any = [
		{
			name: "AI triggers have been pinpointed through the analysis of three specific scenarios as outlined below:",
			sub_sections: [
				{
					name: "",
					value: "Shifts in customer habits, as well as market and geographical conditions, have been monitored over the last 3 to 5 years. This analysis has consistently revealed certain opportunities or risks."
				},
				{
					name: "",
					value: "The detection of certain anomalies that lack substantial data backing. AI will monitor these closely to determine which are likely to become more regular occurrences.The detection of certain anomalies that lack substantial data backing. AI will monitor these closely to determine which are likely to become more regular occurrences."
				},
				{
					name: "",
					value: "A series of potential opportunities and risks have been identified by AI. Although they are not frequently occurring at present, they are forecasted to happen in the future."
				},
			]
		},
	];



	opp_breakdown_id: any = "";
	opp_breakdown_name: any = "";

	rules_breakdown_id: any =  "";
	rules_breakdown_name: any =  "";

	ai_breakdown_id: any =  "";
	ai_breakdown_name: any =  "";

	common_breakdown_id: any =  "";
	common_breakdown_name: any =  "";
	analysisChanged(data) {
		if (data.type == "Opportunities") {
			this.opp_breakdown_id = data.id;
			this.opp_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		} else if (data.type == "Rule Based Triggers") {
			this.rules_breakdown_id = data.id;
			this.rules_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		} else if (data.type == "AI Triggers") {
			this.ai_breakdown_id = data.id;
			this.ai_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		} else if (data.type == "Common Triggers") {
			this.common_breakdown_id = data.id;
			this.common_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		}
	}


	@ViewChild('syncActivitiesModal') syncActivitiesModal: TemplateRef<any>;
	private syncActivitiesModalRef: MatDialogRef<TemplateRef<any>>;
	openSyncActivitiesModal() {
		this.syncActivitiesModalRef = this.dialog.open(
			this.syncActivitiesModal, { disableClose: true }
		);
		this.syncActivitiesModalRef.afterClosed().subscribe((result) => {
			this.closeSyncActivitiesModal();
		});
	}

	closeSyncActivitiesModal() {
		this.syncActivitiesModalRef.close();
	}

	salesforce_sync_loader: boolean = false;
	salesforceSync(data) {
		this.salesforce_sync_loader = true;
		this.openSyncActivitiesModal();
		let route: any = "/syncsalesforceactivities?client_id=" + data.id + "&user_type=Client&opp_type=Opportunity";
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.salesforce_sync_loader = false;
				this.commonService.showToast('success', 'Data Synced Successfully.');
				this.closeSyncActivitiesModal();
			},
			(err) => {
				this.salesforce_sync_loader = false;
				this.commonService.showToast('error', err.error);
			},
		);
	}
}
